import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=656757e7&"
import script from "./InputTextArea.vue?vue&type=script&lang=js&"
export * from "./InputTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports